import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import './../../Style/AddPurchaseTotal.scss'
import { deleteAlert, errorAlert, updateAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { AiFillAppstore } from "react-icons/ai";
import { Paper, TextareaAutosize } from "@mui/material";
import "jspdf-autotable";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../Style/TableStyle.scss'
import { MdEdit } from "react-icons/md";
import DataGridWithActions from "../../Components/DataGridWithActions";
import Autocomplete from "@mui/material/Autocomplete";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddLinkButton, LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import { InteresGridHeader } from "./InteresGridHeader";
import CancelModal from "../../Components/CancelModal";
import OneFieldTotal from "../../Components/OneFieldTotal";

export default function Interes() {
    const [showDetails, setShowDetails] = useState(true);
    const { fiscalYear } = useContext(FiscalYearContext);

    const [showModal, setShowModal] = useState(false);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const loginEmail = LoginUserDetailed();
    const headers = authHeader();

    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        TransactionID: "",
        InvoiceNr: "",
        Date: "",
        AccountID: "",
        Total: "",
        Coment: "",
        ModifiedByUser: "",
        CompanyUnitID: "",
    });

    const [showEditModal, setShowEditModal] = useState(false);
    const [changeButton, setChangeButton] = useState(false)
    const [banks, setBanks] = useState([]);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Interes', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            console.error("Error:", error);
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };


    const fetchBanks = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 102 } });
            setBanks(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };
    // Kodi per fshirjen e nje elementi ne databaz 
    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'Interes' + `/${deleteItemId}`, { headers }
            );
            deleteAlert("Transaksioni është fshirë me sukses");
            fetchData();
        } catch (error) {
            deleteAlert("Transaksioni nuk është fshirë me sukses");
        }
    };

    // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setFormData({
            TransactionID: item.TransactionID,
            InvoiceNr: item.InvoiceNr,
            Date: item.Date,
            AccountID: item.AccountID,
            Total: item.Total,
            Coment: item.Coment,
            ModifiedByUser: loginEmail,
            CompanyUnitID: item.CompanyUnitID,

        });
        setShowEditModal(true);
        setShowDetails(false);
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setChangeButton(true);
    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'Interes', formData, { headers })
            .then((response) => {
                setShowEditModal(false); // Close the edit modal
                setShowDetails(true);
                fetchData();
                setChangeButton(false);
                updateAlert("Fatura e interesit u editua me sukses");
            })
            .catch((error) => {
                // alert("Failed to update State");
                errorAlert("Fatura e interesit nuk është edituar")
            });
    };

    const totalAmount = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Total), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        inv: `${"INS"}-${fiscalYear}-${item.InvoiceNr}`,
        date: (item.Date.substring(0, 10)),
        supplier: item.AccountName,
        total: item.Total,
        deleteItemId: item.TransactionID,
        rowInfo: item
    }));

    //Select list for Supplier
    const handleAutocompleteChangeBanks = (event, value) => {
        if (value) {
            setFormData(prevState => ({
                ...prevState,
                AccountID: value.AccountID
            }));
            setChangeButton(true);
        } else {
            setFormData(prevState => ({
                ...prevState,
                AccountID: ""
            }));
        }
    };

    const defaultPropsBanks = {
        options: banks,
        getOptionLabel: (option) =>
            `${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.AccountName}
                    </span>
                    {/* <button
                        onClick={(e) => {
                            e.stopPropagation();
                            // handleButtonClick(option);
                        }}
                        onMouseEnter={handleOpen}
                        onMouseLeave={handleClose}
                        style={{ marginLeft: 'auto' }}
                    >
                        Click
                    </button> */}
                </li>
            </>
        ),
    };

    const handleConfirm = () => {
        setShowModal(false);
        setChangeButton(false);
        setShowEditModal(false);
        setShowDetails(true);
    };

    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    useEffect(() => {
        fetchBanks();
    }, [])
    return (
        <div className="Crud__Container">
            {/* Shfaqja  e modalit per editimin e te dhenave  */}

            <CancelModal
                open={showModal}
                onClose={() => setShowModal(false)}
                title="Konfirmim"
                description="Jeni të sigurt që dëshironi të anuloni ndryshimet?"
                confirmText="po"     // Custom confirm button text
                cancelText="jo"      // Custom cancel button text
                onConfirm={() => handleConfirm()}
            />

            {showEditModal && (
                <div className="AddPurchaseTotal__Container">
                    <TitleElements
                        icon={MdEdit}
                        title="Ndyshimi i faturës së interesit"
                    />
                    <hr></hr>
                    <div className="AddPurchaseTotal__Container__AllButtons">
                        <div style={{ display: "flex", }}>
                        </div>
                        <div style={{ display: "flex" }}>
                            {changeButton ? (
                                <>
                                    <div style={{ marginLeft: "5px" }}>
                                        <LinkAndClickButton
                                            text="Ruaj"
                                            link="#"
                                            onClick={handleSubmit}
                                        />
                                    </div>
                                    <div style={{ marginLeft: "5px" }}>
                                        <LinkAndClickButton
                                            text="Anulo"
                                            link="#"
                                            onClick={() => {
                                                setShowModal(true);
                                            }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Mbyll"
                                        link="#"
                                        onClick={() => {
                                            setShowDetails(true);
                                            setShowEditModal(false);
                                            setChangeButton(false);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className='header_paper2'></div> */}
                    <HeaderPaperComponent />
                    <form className='AddPurchaseTotal__Container__Format'>
                        <Paper>
                            <Box
                                component="form"
                                sx={{
                                    '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div className='Forma1'>
                                    <div className='Boxx'>
                                        <TextField
                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                            // style={{ width: "594px" }}
                                            id="invoiceNR"
                                            label="Numri Fatures"
                                            variant="outlined"
                                            type="text"
                                            name='InvoiceNr'
                                            value={`INS-${fiscalYear}-${formData.InvoiceNr}`}
                                            aria-readonly
                                        />

                                        <div className='AddPurchaseTotal__Container__Format__Dates'>
                                            <TextField
                                                // style={{ width: "230px" }}
                                                className="AddPurchaseTotal__Container__Format__SameInput"
                                                id="date"
                                                type="date"
                                                variant="outlined"
                                                name='Date'
                                                label="Data Fatures"
                                                value={formData.Date && formData.Date.substring(0, 10)}
                                                onChange={handleInputChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    min: minDate, // Kufizimi minimal i datës
                                                    max: maxDate, // Kufizimi maksimal i datës
                                                }}
                                            />
                                        </div>

                                        <div className="AddPurchaseTotal__Container__Format__Dates">
                                            <Autocomplete
                                                fullWidth
                                                // sx={{ m: 2 }}
                                                {...defaultPropsBanks}
                                                id="AccountID"
                                                name="AccountID"
                                                includeInputInList
                                                onChange={handleAutocompleteChangeBanks}
                                                renderInput={(params) => (
                                                    <TextField {...params}
                                                        label="Banka"
                                                        // variant="filled"
                                                        className="AddPurchaseTotal__Container__Format__SameInput"

                                                    />
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                        overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                    },
                                                }}
                                                value={banks.find(option => option.AccountID === formData.AccountID) || null}
                                            />
                                        </div>
                                        <TextField
                                            // style={{ width: "150px" }}
                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                            label="Total 0"
                                            type="text"
                                            id="Total"
                                            name="Total"
                                            value={formData.Total}
                                            // value={formData.Total !== null && formData.Total !== 0 ? formData.Total.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                            onChange={handleInputChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className='Boxx'>
                                        <TextField
                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                            id="LedgerID"
                                            label="Llogaria Kontabël"
                                            variant="outlined"
                                            type="text"
                                            name='LedgerID'
                                            value="602-Shpenzimet e Financiare"
                                            aria-readonly
                                        />
                                        <TextareaAutosize
                                            style={{ height: "70px", marginLeft: "10px" }}
                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                            id="Coment"
                                            label="Komenti"
                                            type="text"
                                            name='Coment'
                                            value={formData.Coment}
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                            </Box>
                        </Paper>
                    </form>
                </div>
            )}

            {showDetails && (
                <div className="shfaqePermbajtjen">
                    <div className="header_flex">
                        <TitleElements
                            icon={AiFillAppstore}
                            title="Interesi"
                        />
                        <AddLinkButton
                            text="Krijo një interes"
                            icon="bi bi-plus-circle"
                            link="/expences/AddInteres"
                        />
                    </div>
                    <ElementsParagraph text="Forma e interesit: Menaxhoni, shtoni, editoni dhe fshini Fatura të interesit." />
                    <DataGridWithActions
                        columns={InteresGridHeader}
                        rows={rows}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        showPayment={false}
                        height={500}
                    />

                    <OneFieldTotal
                        id={1}
                        label="Interesi"
                        value={totalAmount}
                    />

                </div>
            )}
        </div>
    )
}